import { ViewModel, View } from "binder"
import { GenderSelector } from "src/common/reusableComponents/genderSelector/genderSelector";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { IPersonnel } from "../IPersonnel";
import { PersonnelEditorView } from "./personnelEditor-view"

export class PersonnelEditorViewModel extends ViewModel implements IPersonnel, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this.genderSelector = new GenderSelector(this);
        this.genderSelector.onSelectionChanged = x => this.isMale = x.value;
        this._updater = updater;

    }
    GetDefaultView(): View<ViewModel> {
        return new PersonnelEditorView();
    }
    public getTypeId(): string {
        return "VM-861BF023-9497-4F69-91B0-3F58F2D22D48"
    }

    closePopup(result: any) {
    }
    cloneTo(personnel: IPersonnel) {
        personnel.id = this.id;
        personnel.name = this.name;
        personnel.lastName = this.lastName;
        personnel.nationalCode = this.nationalCode;
        personnel.personnelCode = this.personnelCode;
        personnel.fatherName = this.fatherName;
        personnel.identificationCode = this.identificationCode;
        personnel.birthDate = this.birthDate == null ? null : this.birthDate.clone();
        personnel.comment = this.comment;
        personnel.address = this.address;
        personnel.cellPhone = this.cellPhone;
        personnel.paymentInfo = this.paymentInfo;
        personnel.isMale = this.isMale;
    }

    private _updater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set lastName(v: string) { this._lastName = v; } public get lastName(): string { return this._lastName; } private _lastName: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode; } private _nationalCode: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode; } private _personnelCode: string;
    public set fatherName(v: string) { this._fatherName = v; } public get fatherName(): string { return this._fatherName; } private _fatherName: string;
    public set identificationCode(v: string) { this._identificationCode = v; } public get identificationCode(): string { return this._identificationCode; } private _identificationCode: string;
    public set birthDate(v: moment.Moment) { this._birthDate = v; } public get birthDate(): moment.Moment { return this._birthDate; } private _birthDate: moment.Moment;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address; } private _address: string;
    public set cellPhone(v: string) { this._cellPhone = v; } public get cellPhone(): string { return this._cellPhone; } private _cellPhone: string;
    public set isMale(v: boolean) {
        this._isMale = v;
        this.genderSelector.selectById(v ? 'male' : 'female');
    } public get isMale(): boolean { return this._isMale; } private _isMale: boolean;
    public set genderSelector(v: GenderSelector) { this._genderSelector = v; } public get genderSelector(): GenderSelector { return this._genderSelector; } private _genderSelector: GenderSelector;
    public set paymentInfo(v: string) { this._paymentInfo = v; } public get paymentInfo(): string { return this._paymentInfo; } private _paymentInfo: string;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable;} private _isDisable: boolean;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit;} private _canEdit: boolean;
    
    
    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), translate("personnelEditor-viewModel.error", {}));
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess(translate("personnelEditor-viewModel.successfulPersonnel", {}), translate("personnelEditor-viewModel.successfulRegistration", {}));
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(translate("personnelEditor-viewModel.personnelError", {}), translate("personnelEditor-viewModel.error", {}));
            } finally {
                this.isLoading = false;
            }
        }
    }
    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(translate("personnelEditor-viewModel.personnelNameError", {}));
        }
        if (stringIsNullOrEmpty(this.lastName)) {
            result.push(translate("personnelEditor-viewModel.personnelFamilyError", {}));
        }
        if (stringIsNullOrEmpty(this.fatherName)) {
            result.push(translate("personnelEditor-viewModel.personnelFatherNameError", {}))
        }
        if (this.genderSelector.selectedItem == null) {
            result.push(translate("personnelEditor-viewModel.personnelGenderError", {}));
        }
        if (stringIsNullOrEmpty(this.identificationCode)) {
            result.push(translate("personnelEditor-viewModel.birthCertificateNumberError", {}));
        }
        if (stringIsNullOrEmpty(this.nationalCode)) {
            result.push(translate("personnelEditor-viewModel.nationalCodeError", {}));
        }
        if (stringIsNullOrEmpty(this.personnelCode)) {
            result.push(translate("personnelEditor-viewModel.personnelCodeError", {}));
        }
        if (this.birthDate == null) {
            result.push(translate("personnelEditor-viewModel.birthDateError", {}));
        }
        return result;
    }

}

export interface IServerUpdater {
    execute(personnel: IPersonnel): Promise<any>;
}

export class PersonnelInserter implements IServerUpdater {
    async execute(personnel: IPersonnel): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/CreateNewPersonnel', {
                Name: personnel.name,
                LastName: personnel.lastName,
                NationalCode: personnel.nationalCode,
                PersonnelCode: personnel.personnelCode,
                FatherName: personnel.fatherName,
                IdentificationCode: personnel.identificationCode,
                BirthDate: personnel.birthDate,
                Comment: personnel.comment,
                Address: personnel.address,
                CellPhone: personnel.cellPhone,
                PaymentInfo: personnel.paymentInfo,
                IsMale: personnel.isMale
            });
            if (result.IsSuccessful == false) {
                throw "Error Saving Personnel";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

export class PersonnelUpdater implements IServerUpdater {
    async execute(personnel: IPersonnel): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/UpdatePersonnel', {
                Id: personnel.id,
                Name: personnel.name,
                LastName: personnel.lastName,
                NationalCode: personnel.nationalCode,
                PersonnelCode: personnel.personnelCode,
                FatherName: personnel.fatherName,
                IdentificationCode: personnel.identificationCode,
                BirthDate: personnel.birthDate,
                Comment: personnel.comment,
                Address: personnel.address,
                CellPhone: personnel.cellPhone,
                PaymentInfo: personnel.paymentInfo,
                IsMale: personnel.isMale
            });
            if (result.IsSuccessful == false) {
                throw "Error Saving Personnel";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}
